/**
 * Ayarlar ekranının ortak kartları (M6f G6-32, G6-33): web ofiste ve gemide aynı kart sırası ve
 * aynı metinler. Kart başlıkları Title Case (G6-39).
 */
export const settingsEn = {
  subtitle:
    "Manage the interface language, your account and this computer's connection to the ship server.",
  subtitleOffice: 'Manage the interface language, your account and your company’s branding.',
  language: {
    title: 'Language & Regional',
    interface: 'Interface language',
    help: 'Choose the language of menus and screens on this computer. Records are stored the same in every language.',
    dateFormat: 'Date and time',
    dateFormatValue: '{{example}} (day.month.year, 24-hour)',
    displaySize: 'Display size',
    displaySizeHelp: 'Makes text and controls larger or smaller. Ctrl + and Ctrl − also work.',
  },
  account: {
    title: 'Account',
    name: 'Name',
    email: 'E-mail',
    rank: 'Rank',
    role: 'Role',
    security: 'Sign-in security',
    changePassword: 'Change password',
    signOut: 'Sign out',
    // İki adımlı doğrulama isteğe bağlı (sahip 2026-11-01): ofiste Account kartının güvenlik bölümü
    password: 'Password',
    passwordHelp: 'Changing it signs you out on your other devices',
    twoStep: 'Two-step verification',
    twoStepHelp: 'Authenticator app code at sign-in, in addition to your password',
    twoStepOn: 'On',
    twoStepOff: 'Off',
    turnOn: 'Turn on',
    turnOff: 'Turn off',
    // Tanıtım şirketi ve paylaşılan test hesabı (ADR 0148 §6): açıklama satırında, rozet ve düğme yok
    twoStepUnavailable: 'Not available for this account',
  },
  branding: { title: 'Company Branding' },
  software: {
    title: 'Software',
    product: 'Product',
    version: 'Version',
    updates: 'Updates',
    upToDate: 'Up to date',
    downloading: 'Downloading update…',
    ready: '{{version}} ready to install',
    install: 'Restart to update',
    disabled: 'Automatic updates are off in this installation',
    error: 'Could not check for updates',
    office: 'Always the latest version (web application)',
  },
  // About (M9a; NR467 Pt C Ch 3 Sec 3 7.1.1)
  about: {
    title: 'About Felixmate',
    open: 'About Felixmate',
    description: 'Ship ISM and planned maintenance software',
    version: 'Version',
    build: 'Build',
    manufacturer: 'Manufacturer',
    copyright: '© {{year}} {{manufacturer}}. All rights reserved.',
    close: 'Close',
  },
  // Yenilikler (sürüm notları; M17, ADR 0064)
  whatsNew: {
    title: "What's new",
    open: "What's new",
    close: 'Close',
    new: 'New',
    unseen: '(new notes)',
  },
};

export type SettingsResources = typeof settingsEn;

export const settingsTr: SettingsResources = {
  subtitle: 'Arayüz dilini, hesabınızı ve bu bilgisayarın gemi sunucusuyla bağlantısını yönetin.',
  subtitleOffice: 'Arayüz dilini, hesabınızı ve şirketinizin markasını yönetin.',
  language: {
    title: 'Dil ve Bölge',
    interface: 'Arayüz dili',
    help: 'Bu bilgisayardaki menü ve ekranların dilini seçin. Kayıtlar her dilde aynı saklanır.',
    dateFormat: 'Tarih ve saat',
    dateFormatValue: '{{example}} (gün.ay.yıl, 24 saat)',
    displaySize: 'Görünüm boyutu',
    displaySizeHelp: 'Yazıları ve denetimleri büyütür ya da küçültür. Ctrl + ve Ctrl − de çalışır.',
  },
  account: {
    title: 'Hesap',
    name: 'Ad',
    email: 'E-posta',
    rank: 'Rütbe',
    role: 'Rol',
    security: 'Giriş güvenliği',
    changePassword: 'Parolayı değiştir',
    signOut: 'Çıkış yap',
    password: 'Parola',
    passwordHelp: 'Değiştirince diğer cihazlarınızdaki oturumlar kapanır',
    twoStep: 'İki adımlı doğrulama',
    twoStepHelp: 'Girişte parolanıza ek olarak doğrulama uygulamasındaki kod',
    twoStepOn: 'Açık',
    twoStepOff: 'Kapalı',
    turnOn: 'Aç',
    turnOff: 'Kapat',
    twoStepUnavailable: 'Bu hesapta kullanılamaz',
  },
  branding: { title: 'Şirket Markası' },
  software: {
    title: 'Yazılım',
    product: 'Ürün',
    version: 'Sürüm',
    updates: 'Güncellemeler',
    upToDate: 'Güncel',
    downloading: 'Güncelleme indiriliyor…',
    ready: '{{version}} kurulmaya hazır',
    install: 'Güncellemek için yeniden başlat',
    disabled: 'Bu kurulumda otomatik güncelleme kapalı',
    error: 'Güncelleme denetlenemedi',
    office: 'Her zaman son sürüm (web uygulaması)',
  },
  about: {
    title: 'Felixmate hakkında',
    open: 'Felixmate hakkında',
    description: 'Gemi ISM ve planlı bakım yazılımı',
    version: 'Sürüm',
    build: 'Derleme',
    manufacturer: 'Üretici',
    copyright: '© {{year}} {{manufacturer}}. Tüm hakları saklıdır.',
    close: 'Kapat',
  },
  whatsNew: {
    title: 'Yenilikler',
    open: 'Yenilikler',
    close: 'Kapat',
    new: 'Yeni',
    unseen: '(yeni notlar)',
  },
};
